import React, { Dispatch, SetStateAction } from 'react';

import { Box } from '@/components/lib/components';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';

import { setDepositAmount } from '../hooks/use-deposit-status-store';
import { QuickDepositButton } from './QuickDepositButton';

type QuickDepositButtonsSectionProps = {
    selectedValue: string;
    setInputValue: Dispatch<SetStateAction<string>>;
    quickDepositValues: Record<string, string>;
};

export const QuickDepositButtonsSection = ({
    selectedValue,
    setInputValue,
    quickDepositValues,
}: QuickDepositButtonsSectionProps): React.ReactElement | null => {
    const handlePress = (value: string) => {
        BetrAnalytics.trackProductEvent(AnalyticsEvent.DEPOSIT_QUICKBUTTON, { amount: value });
        // the quick buttons now add to the current value instead of replacing it
        const quickAmountValue = parseFloat(value);
        const currentValue = parseFloat(selectedValue);
        const valueToSet = quickAmountValue + currentValue;
        setDepositAmount(valueToSet.toString());
        setInputValue(valueToSet.toString());
    };
    return quickDepositValues ? (
        <Box flexDirection="row" justifyContent="space-evenly" flexGrow={1} columnGap={'s6'}>
            {Object.values(quickDepositValues).map(value => (
                <QuickDepositButton
                    key={`quick-deposit-button-${value}`}
                    label={`+$${value}`}
                    isSelected={false}
                    onPress={() => handlePress(value)}
                />
            ))}
        </Box>
    ) : null;
};
